import {
  GET_SMART_ANALYSIS_REQUEST,
  GET_SMART_ANALYSIS_SUCCESS,
  GET_SMART_ANALYSIS_FAILURE,
  RESET_MATCH_CARD

} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  let hasStatistics;

  switch (action.type) {
    case GET_SMART_ANALYSIS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_SMART_ANALYSIS_SUCCESS:

      hasStatistics = !!action.payload.spotLights
        || !!action.payload.home
        || !!action.payload.away
        || !!action.payload.lastMatch
        || !(action.payload.oddPredicts
          && action.payload.oddPredicts.length === 0);

      return { ...state, data: { ...action.payload }, hasStatistics, isLoading: false, error: null };
    case GET_SMART_ANALYSIS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
